<template>
  <v-btn
      @click="$emit('click')"
      small
      icon
      :disabled="disabled"
      style="border: 2px solid #e2e2e5;background-color: white"
      color="error"
  >
    <v-icon small>delete</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>